// Environment Configuration Validator
// This utility helps validate that all required configuration values are properly set
// Values are loaded from /config.json at runtime

import { getConfig } from "./runtimeConfig";

export const validateEnvironmentConfig = () => {
  const config = getConfig();
  
  const requiredVars = [
    'REACT_APP_CLIENT_ID',
    'REACT_APP_TENANT_ID', 
    'REACT_APP_REDIRECT_URI',
    'REACT_APP_ENV',
    'REACT_APP_API_BASE_URL',
    'REACT_APP_AUTH_API_URL',
    'REACT_APP_NAME'
  ];

  const missingVars = [];

  requiredVars.forEach(varName => {
    const value = config[varName];
    
    if (!value) {
      missingVars.push(varName);
    }
  });

  // Special handling for local development
  if (config.REACT_APP_ENV === 'development') {
    return { isValid: true, config, environment: 'development' };
  }

  if (missingVars.length > 0) {
    console.error('❌ Missing required configuration values:', missingVars);
    return { isValid: false, missingVars, config };
  }

  const environment = config.REACT_APP_ENV;

  return { isValid: true, config, environment };
};

export const getEnvironmentInfo = () => {
  const config = getConfig();
  const env = config.REACT_APP_ENV || 'development';
  // Only skip auth if in development mode
  const skipAuth = env === 'development';
  
  return {
    environment: env,
    isProduction: env === 'production',
    isStaging: env === 'staging', 
    isDevelopment: env === 'development',
    skipAuth,
    ssoEnabled: !skipAuth
  };
};